














































import { Component, Vue } from 'vue-property-decorator';
import { CNodeTopicDetail } from '@/interface';
import { topicActions, TopicModule } from '@/store/types';
import { namespace } from 'vuex-class';
import {
  CollectOrDeCollect,
  TopicState,
} from '@/store/interface';
import { Log } from '@/utils';
import '@/directives/directive-photoswipe';

const Module = namespace(TopicModule);

@Component
export default class TopicDetail extends Vue {
  @Module.State((state: TopicState) => state.topicDetail)
  private topicDetail!: CNodeTopicDetail;
  @Module.Action(topicActions.COLLECT_OR_DE_COLLECT)
  private collectOrDeCollect!: CollectOrDeCollect;

  private get scroll() {
    return document.body.scrollHeight >= 1000;
  }
  private toNewReply() {
    this.$router.push({path: `/topic/${this.$route.params.id}/newreply`});
  }
}
